/**
 * Returns a true boolean value with the given probability.
 * @param probability - The probability of the boolean value being true, from 0 to 1
 * @returns boolean
 */
export function withProbability(probability: number): boolean {
  return Math.random() < probability;
}
